import { apiFileFetch } from '..';
import { FileStatusType } from './types';

export type FileStatusResponse = {
  status: FileStatusType;
  failureCode?: string;
};

export type TrackFileBody = {
  fileId?: string;
  actionType: 'Download' | 'Preview';
  ownerId?: string;
  ownerType?: 'user' | 'entity' | 'fund' | 'thread';
  documentType?: 'HistoricalPerformance' | 'PricingHistory';
};

export const _trackFile = (body: TrackFileBody) => {
  return apiFileFetch('/files/track', {
    method: 'POST',
    body,
  });
};

export const _fileStatus = (id: string) => {
  return apiFileFetch<FileStatusResponse>(`/files/${id}/status`, {
    method: 'GET',
  });
};
